module.exports = "/_next/static/images/2e7c5aa4c8fe335bc11e50ea97ef3d36-cuenta.png";